// Dependencies
import { FC } from "react";
import { useQuery } from "react-query";
import { useSnackbar } from "notistack";
import { useLocation, useNavigate } from "react-router-dom";

// api
import { emailConfirm } from "~/services/auth";

// Components
import { If } from "jsx-control-statements";

// Routes
import config from "~/config";

// Types
import { TQueryError } from "~/types";

// Themes
import theme from "~/components/Common/Theme";

// Styles
import {
  StyledLoading,
  StyledErrorTitle,
  StyledHashLoader,
  StyledLoadingDesc,
  StyledErrorMessage,
  StyledLoadingHeader,
  StyledActiveBackground,
} from "./ActiveAccount.styled";

interface ActiveAccountProps {}

const ActiveAccount: FC<ActiveAccountProps> = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  // get token in url
  const search = useLocation().search;
  const token = new URLSearchParams(search).get("token") || "";

  // Queries
  const emailConfirmQuery = useQuery({
    queryKey: ["email-confirm", token],
    queryFn: () => emailConfirm(token),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    onSuccess: () => {
      enqueueSnackbar("Active account success!", { variant: "success" });
      navigate(config.routes.login);
    },
    onError: (error: TQueryError) => {},
  });

  return (
    <StyledActiveBackground>
      <StyledLoading>
        <StyledLoadingHeader variant={"h1"}>
          Welcome to Money Lover
        </StyledLoadingHeader>
        <If condition={emailConfirmQuery.isLoading}>
          <StyledLoadingDesc variant="h4">
            Your account is activating...
          </StyledLoadingDesc>
          <StyledHashLoader color={theme.palette.primary.main} />
          <StyledLoadingDesc variant="h4">Just a moment!</StyledLoadingDesc>
        </If>
        <If condition={emailConfirmQuery.isError}>
          <StyledErrorTitle>Opp! An Error occurred!</StyledErrorTitle>
          <StyledErrorMessage>
            {emailConfirmQuery?.error?.message}
          </StyledErrorMessage>
          <StyledLoadingDesc>
            Please check your email and register again!
          </StyledLoadingDesc>
        </If>
      </StyledLoading>
    </StyledActiveBackground>
  );
};

export default ActiveAccount;
